import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './Slide.css';
const Slide = (props) => {
    var _a;
    return (_jsxs("div", { className: `slide ${((_a = props.country) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || 'norge'}`, children: [_jsx("span", { children: props.title }), props.children] }));
};
export default Slide;
